// extracted by mini-css-extract-plugin
export default {"wrapper":"_7d11d78b","header":"_27a644a7","body":"_6c2bd3a8"};